import { Audio } from 'expo-av';

// Reference-counted overrides of `playsInSilentModeIOS`. Each call to
// `enableAudioPlaybackInSilentMode` must be paired with one call to
// `disableAudioPlaybackInSilentMode` so independent consumers can opt in
// without clobbering each other.
let refCount = 0;
let pending: Promise<void> | null = null;

const applyAudioMode = (playsInSilentModeIOS: boolean) => {
  pending = Audio.setAudioModeAsync({ playsInSilentModeIOS }).catch(e => {
    console.error('failed to configure audio mode: ', e);
  });
  return pending;
};

/**
 * Sets `playsInSilentModeIOS: true` on the global expo-av audio session so
 * playback continues even when the iPhone ringer switch is off. Call this
 * sparingly — it overrides the user's silent-mode preference and should
 * only be used for sounds that are essential to the feature (e.g.,
 * recording start/stop chimes the user explicitly opted into).
 *
 * Reference-counted: pair every call with `disableAudioPlaybackInSilentMode`
 * (typically via the `useAudioPlaybackInSilentMode` hook).
 */
export const enableAudioPlaybackInSilentMode = () => {
  refCount++;
  if (refCount === 1) {
    void applyAudioMode(true);
  }
  return pending ?? Promise.resolve();
};

/**
 * Decrement the silent-mode-override refcount. When it reaches zero the
 * audio session is reverted to `playsInSilentModeIOS: false` (the expo-av
 * default).
 */
export const disableAudioPlaybackInSilentMode = () => {
  if (refCount === 0) return pending ?? Promise.resolve();
  refCount--;
  if (refCount === 0) {
    void applyAudioMode(false);
  }
  return pending ?? Promise.resolve();
};
